import { withStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth, landingPage } from '../../constants/actions'
import { getIsAuthenticated, getLandingPage } from '../../selectors'
import LandingPage from './component'

const styles = () => ({})

export const mapStateToProps = state => ({
  eventLogo: get(state, 'landingPage.eventLogo'),
  headerLogo: get(state, 'landingPage.headerLogo'),
  landingPageImage: get(state, 'landingPage.landingPageImage'),
  landingPageLogo: get(state, 'landingPage.landingPageLogo'),
  landingPage: getLandingPage(state),
  sponsorLogos: get(state, 'landingPage.sponsorLogos'),
  isAuthenticated: getIsAuthenticated(state),
  showLoadingIndicator: get(state, 'common.showLoadingIndicator'),
})

export default connect(mapStateToProps, {
  getLandingPage: landingPage.getLandingPage,
  getPublicCert: auth.getPublicCert,
  signout: auth.signout,
  setLandingPageSubdomain: landingPage.setLandingPageSubdomain,
})(withStyles(styles)(LandingPage))
